/**
 * @param {number} ms - The number of milliseconds to sleep
 * @example
 * await sleep(1000)
 * console.log('Hello')
 * // After 1 second, 'Hello' will be printed
 */
// eslint-disable-next-line promise/param-names
export const sleep = ms => new Promise(r => setTimeout(r, ms))
